import React from 'react';
import { SolicitarReembolsoPage } from '../pages/solicitar-reembolso/solicitar-reembolso.page';

export const SolicitarReembolsoTemplate: React.FC = () => {
  return <SolicitarReembolsoPage />;
};
